import type { IChallenge } from "@bbj-types/challenge";
import { useCallback } from "react";
import { axiosChallengesWithoutInterceptors } from "./axios";

export const useGetChallenges = () => {
  const [state, execute, cancel] = axiosChallengesWithoutInterceptors<IChallenge[], void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { autoCancel: false }
  );

  const callback = useCallback(() => {
    return execute();
  }, [execute]);

  return [state, callback, cancel] as const;
};
